var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadquearterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.15261837610274,
    height: 46.15261837610274,
    viewBox: "267.23144416238574 157.9677012703322 46.15261837610274 46.15261837610274",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6654003158 0 0 0.6654003158 290.3077533504 181.0440104584)",
    id: "NhnG8qlgz8a3pTyCuURnQ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(39,236,227)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,234)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 0 -34.68034 C 19.14355 -34.68034 34.68034 -19.14355 34.68034 0 C 34.68034 19.14355 19.14355 34.68034 0 34.68034 C -19.14355 34.68034 -34.68034 19.14355 -34.68034 0 C -34.68034 -19.14355 -19.14355 -34.68034 0 -34.68034 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 290.3077533504 181.0440104584)",
    id: "3ihsEpW2yY5DYBJ-Xb3dM"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.7363258456, -15.3299)",
    d: "M 8.58859 6.20695 C 11.929 3.785 13.5992 2.57403 15.5067 2.5042 C 15.6597 2.4986 15.8129 2.4986 15.9659 2.5042 C 17.8734 2.57403 19.5436 3.785 22.884 6.20695 C 26.2245 8.62889 27.8947 9.83986 28.5507 11.6286 C 28.6033 11.7721 28.6506 11.9175 28.6926 12.0645 C 29.2155 13.8964 28.5775 15.8558 27.3016 19.7746 L 25.1458 26.3955 C 24.8033 27.4476 23.8209 28.1598 22.7124 28.1598 C 21.2994 28.1598 20.1538 27.0167 20.1538 25.6065 L 20.1538 22.1704 C 20.1538 20.8472 19.079 19.7746 17.7531 19.7746 L 13.7195 19.7746 C 12.3936 19.7746 11.3188 20.8472 11.3188 22.1704 L 11.3188 25.6065 C 11.3188 27.0167 10.1733 28.1598 8.76018 28.1598 C 7.65172 28.1598 6.66933 27.4476 6.3268 26.3955 L 4.17106 19.7746 C 2.89513 15.8558 2.25716 13.8964 2.78005 12.0645 C 2.822 11.9175 2.86933 11.7721 2.92195 11.6286 C 3.57794 9.83986 5.24816 8.62889 8.58859 6.20695 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadquearterIcon);
export default __webpack_public_path__ + "static/media/headquearter_icon.6e0d37d982380524a6c5b2ce2a04bab6.svg";
export { ForwardRef as ReactComponent };